/**
 *
 * @param currentNumber // The number needed to verify
 * @param amountOfCharacters  // How many characters should it be
 * @param character // the character to fill
 * @returns  // the string for example
 * // 2, 3, 0 => 002
 * // 23, 2, 0 => 23
 * // 34, 4, XX => XX34
 */
export const fillNumberWithCharacters = (
  currentNumber: number,
  amountOfCharacters: number,
  character: string,
): string => {
  const amountOfCharactersInNumber = String(currentNumber);
  if (amountOfCharactersInNumber.length >= amountOfCharacters) {
    return String(currentNumber);
  }
  let word = String(currentNumber);
  for (let i = 0; i < amountOfCharacters - amountOfCharactersInNumber.length; i++) {
    word = `${character}${word}`;
  }
  return word;
};
